var TOKEN_TYPES;
(function(TOKEN_TYPES) {
    TOKEN_TYPES["ADDRESS"] = "a";
    TOKEN_TYPES["BRAND"] = "b";
    TOKEN_TYPES["BRAND_INVOICE"] = "bi";
    TOKEN_TYPES["BRAND_ORDER"] = "bo";
    TOKEN_TYPES["BRAND_REVIEW"] = "br";
    TOKEN_TYPES["CART"] = "c";
    TOKEN_TYPES["CART_ITEM"] = "ci";
    TOKEN_TYPES["MESSENGER_CONVERSATION"] = "mc";
    TOKEN_TYPES["MESSENGER_MESSAGE"] = "mm";
    TOKEN_TYPES["MEMBERSHIP"] = "ms";
    TOKEN_TYPES["DOCUMENT"] = "d";
    TOKEN_TYPES["EXTERNAL"] = "ex";
    TOKEN_TYPES["FLASH_SALE"] = "fs";
    TOKEN_TYPES["FLASH_SALE_ITEM"] = "fsi";
    TOKEN_TYPES["HOST_PROCESS"] = "hp";
    TOKEN_TYPES["IMAGE"] = "i";
    TOKEN_TYPES["INSTRUMENT_LINK"] = "il";
    TOKEN_TYPES["INVENTORY_ITEM"] = "it";
    TOKEN_TYPES["ORDER"] = "o";
    TOKEN_TYPES["ORDER_ITEM"] = "oi";
    TOKEN_TYPES["OUTGOING_EMAIL"] = "oe";
    TOKEN_TYPES["PAYMENT"] = "pay";
    TOKEN_TYPES["PAYMENT_PLAN"] = "ppl";
    TOKEN_TYPES["PRODUCT"] = "p";
    TOKEN_TYPES["PRODUCT_COLLECTION"] = "pc";
    TOKEN_TYPES["PRODUCT_COLLECTION_ITEM"] = "pci";
    TOKEN_TYPES["PRODUCT_OPTION"] = "po";
    TOKEN_TYPES["REFUND"] = "rfd";
    TOKEN_TYPES["RETAILER"] = "r";
    TOKEN_TYPES["RETURN_ORDER"] = "ro";
    TOKEN_TYPES["SCHEDULED_PICKUP"] = "sp";
    TOKEN_TYPES["SHIPMENT"] = "s";
    TOKEN_TYPES["SHIPPING_OPTION"] = "so";
    TOKEN_TYPES["USER"] = "u";
})(TOKEN_TYPES || (TOKEN_TYPES = {}));
var TOKEN_REGEX = /^(\w{1,4})_.*$/;
export var getNormalizedUrl = function(path) {
    return path.split("/").map(function(segment) {
        for(var token in TOKEN_TYPES){
            if (!TOKEN_TYPES.hasOwnProperty(token)) {
                continue;
            }
            if (segment.startsWith("".concat(// @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
            TOKEN_TYPES[token], "_"))) {
                return "{".concat(token, "}");
            }
        }
        var match = segment.match(TOKEN_REGEX);
        if (match) {
            var _match_;
            var _match__toUpperCase;
            return "{".concat((_match__toUpperCase = (_match_ = match[1]) === null || _match_ === void 0 ? void 0 : _match_.toUpperCase()) !== null && _match__toUpperCase !== void 0 ? _match__toUpperCase : "", "}");
        }
        return segment;
    }).join("/").substring(0, 255);
};
